
import React from "react";
import { Box, CircularProgress, Modal, Divider, Typography } from "@mui/material"
import { useModalesStore } from "../../../store";



export const ModalFormUno = ({ titulo="Sin Titulo", onClose, valor, color='white', children }) => {


    const { modalFormUno } = useModalesStore(); 
    

    return (

        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={ modalFormUno }
            onClose={ onClose }
            closeAfterTransition
        >
            <>
                {(valor)
                ?   <Box className="modal-estilo" sx={{ width:{xs:'80%', sm:'65%', md:'50%'} }}>
                        <Box sx={{px:3}}>
                            <Typography variant='h4' align='center' sx={{mb:1}} >{ titulo }</Typography>
                            <Divider sx={{mb:4}}  />
                        </Box>
                        { children }
                    </Box>

                :   <Box sx={{ display: 'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', width:'100%', height:'100vh' }}>
                        <CircularProgress size="50px" />
                        <Typography sx={{fontSize:23, mt:2, color:color}} >Cargando Información...</Typography>
                    </Box>

                }
            </>
        </Modal>
    )

}
